"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatencyEstimator = void 0;
var vpt_abr_common_1 = require("@sky-uk-ott/vpt-abr-common");
var network_estimation_constants_1 = require("./network-estimation-constants");
var network_estimation_types_1 = require("./network-estimation-types");
var create_smoother_1 = require("./smoothers/create-smoother");
var create_statistical_aggregator_1 = require("./statistical-aggregators/create-statistical-aggregator");
var getSampleValue = function (sample) { return sample.latencyMs; };
var LatencyEstimator = /** @class */ (function () {
    function LatencyEstimator(logger, config) {
        if (config === void 0) { config = {}; }
        this.sampleHandlerId = 0;
        this.sampleHandlers = new Map();
        this.samples = [];
        this.isDestroyed = false;
        this.logger = logger.withContext('Latency Estimator');
        this.logger.verbose('Received config: ', config);
        this.config = __assign({ numberOfStoredSamples: network_estimation_constants_1.DEFAULT_STORED_ESTIMATOR_SAMPLES }, config);
    }
    LatencyEstimator.prototype.sample = function (latencyMs, timeRecorded, trackType) {
        if (trackType && [network_estimation_types_1.NetworkSampleType.Audio, network_estimation_types_1.NetworkSampleType.Video].includes(trackType)) {
            var sample_1 = { latencyMs: latencyMs, timeRecorded: timeRecorded };
            this.samples = __spreadArray(__spreadArray([], this.samples, true), [sample_1], false);
            this.samples = vpt_abr_common_1.ArrayUtils.lastItems(this.samples, this.config.numberOfStoredSamples);
            this.sampleHandlers.forEach(function (aggregator) {
                aggregator.sample(sample_1);
            });
        }
    };
    LatencyEstimator.prototype.getSmoother = function (smootherConfig) {
        var _this = this;
        var smoother = (0, create_smoother_1.createSmoother)(this.logger, smootherConfig, getSampleValue);
        var unregister = this.registerSampleHandler(smoother);
        return {
            getValue: function () {
                _this.checkIsDestroyed();
                return smoother.getValue();
            },
            unregister: unregister,
        };
    };
    LatencyEstimator.prototype.getStatisticalAggregator = function (statisticalAggregatorConfig) {
        var _this = this;
        var aggregator = (0, create_statistical_aggregator_1.createStatisticalAggregator)(this.logger, statisticalAggregatorConfig, getSampleValue);
        var unregister = this.registerSampleHandler(aggregator);
        return {
            getValue: function () {
                _this.checkIsDestroyed();
                return aggregator.getValue();
            },
            unregister: unregister,
        };
    };
    LatencyEstimator.prototype.clear = function () {
        this.samples = [];
        this.sampleHandlers.forEach(function (smoother) {
            smoother.clear();
        });
    };
    LatencyEstimator.prototype.destroy = function () {
        this.sampleHandlers.clear();
        this.clear();
    };
    LatencyEstimator.prototype.checkIsDestroyed = function () {
        if (this.isDestroyed) {
            this.logger.error('ERROR: `getEstimate` called on a destroyed Bandwidth Estimator');
        }
    };
    LatencyEstimator.prototype.registerSampleHandler = function (sampleHandler) {
        var _this = this;
        var id = this.sampleHandlerId++;
        this.samples.forEach(function (s) { return sampleHandler.sample(s); });
        this.sampleHandlers.set(id, sampleHandler);
        return function () { return _this.sampleHandlers.delete(_this.sampleHandlerId); };
    };
    return LatencyEstimator;
}());
exports.LatencyEstimator = LatencyEstimator;
